var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestingicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new_releases_24dp_5F6368_FILL1_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.05 39.375L11.725 33.775L5.425 32.375L6.0375 25.9L1.75 21L6.0375 16.1L5.425 9.625L11.725 8.225L15.05 2.625L21 5.1625L26.95 2.625L30.275 8.225L36.575 9.625L35.9625 16.1L40.25 21L35.9625 25.9L36.575 32.375L30.275 33.775L26.95 39.375L21 36.8375L15.05 39.375ZM19.1625 27.2125L29.05 17.325L26.6 14.7875L19.1625 22.225L15.4 18.55L12.95 21L19.1625 27.2125Z",
    fill: "#D9E8F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestingicon);
export default __webpack_public_path__ + "static/media/testing+icon.aa9ad7c089f58c91bbd4ddee1cb44277.svg";
export { ForwardRef as ReactComponent };